class WishlistManager {
  constructor() {
    this.storageKey = 'etmy_wishlist';
    this.init();
  }

  getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey) || '[]');
    } catch (e) { return []; }
  }

  saveWishlist(list) {
    localStorage.setItem(this.storageKey, JSON.stringify(list));
    this.updateBadge(list.length);
  }

  updateBadge(count) {
    const badge = document.querySelector('.wishlist-count-badge');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  toggle(productId) {
    const list = this.getWishlist();
    const id = String(productId);
    const idx = list.indexOf(id);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push(id);
    }
    this.saveWishlist(list);
    return list.includes(id);
  }

  isInWishlist(productId) {
    return this.getWishlist().includes(String(productId));
  }

  initButtons() {
    const buttons = document.querySelectorAll('.wishlist-btn');
    for (const btn of buttons) {
      const productId = btn.dataset.productId;
      this.updateButton(btn, this.isInWishlist(productId));
      btn.addEventListener('click', () => {
        const nowIn = this.toggle(productId);
        this.updateButton(btn, nowIn);
      });
    }
    this.updateBadge(this.getWishlist().length);
  }

  updateButton(btn, inList) {
    const icon = btn.querySelector('.wishlist-icon');
    const text = btn.querySelector('.wishlist-btn-text');
    if (inList) {
      if (icon) icon.style.fill = 'currentColor';
      if (text) text.textContent = 'Added';
      btn.style.color = '#F59E0B';
    } else {
      if (icon) icon.style.fill = 'none';
      if (text) text.textContent = 'Add to Favorite';
      btn.style.color = '';
    }
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initButtons());
    } else {
      this.initButtons();
    }
  }
}

window.wishlistManager = new WishlistManager();
